module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-henkel-2-ec2bb959cc806353726dbbebcc0e52a8.jpg";